import api from '../api';

import { ParamsCustomerCharges } from 'utils/typeServices';

type ParamsResponse = {
    Data: Array<ParamsCustomerCharges>;
}

export const GetBillingsByCustomerId = async ({ token }: { token: string }) => {
    try {
        const { data } = await api.get<ParamsResponse>('/v1/Pagamento/GetBillingsByCustomerId', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
